import { useCallback, useState } from "react";
import clsx from "clsx";
import { Entity } from "@/domains/createEntity/constants/entity";
import CrateEntityBusinessFormContainer from "@/domains/createEntity/containers/forms/CrateEntityBusinessFormContainer";
import CrateEntityGasStationFormContainer from "@/domains/createEntity/containers/forms/CrateEntityGasStationFormContainer";
import CrateEntityHouseFormContainer from "@/domains/createEntity/containers/forms/CrateEntityHouseFormContainer";
import CrateEntityInteriorList from "@/domains/createEntity/containers/forms/CrateEntityInteriorListContainer";
import CreateStreetAddressFormContainer from "@/domains/createEntity/containers/forms/address/CreateStreetAddressFormContainer";
import CrateEntityInteriorFormContainer from "@/domains/createEntity/containers/forms/interior/CrateEntityInteriorFormContainer";
import CreateEntityMenu from "@/domains/createEntity/components/CreateEntityMenu";
import CreateEntityWrapper from "@/domains/createEntity/components/CreateEntityWrapper";

const form = {
  [Entity.House]: CrateEntityHouseFormContainer,
  [Entity.Business]: CrateEntityBusinessFormContainer,
  [Entity.GasStation]: CrateEntityGasStationFormContainer,
  [Entity.Interior]: CrateEntityInteriorFormContainer,
  [Entity.InteriorList]: CrateEntityInteriorList,
  [Entity.Address]: CreateStreetAddressFormContainer,
};

type Props = {
  isOpen: boolean;
};

export default function CreateEntityContainer({ isOpen }: Props) {
  const [currentEntity, setCurrentEntity] = useState<Entity | null>(null);

  const onChangeHandler = useCallback((value: Entity) => {
    setCurrentEntity((state) => (state === value ? null : value));
  }, []);

  const Component = currentEntity ? form[currentEntity] : null;

  return (
    <CreateEntityWrapper onMouseLeave={() => {}} className={clsx({ hidden: !isOpen })}>
      <CreateEntityMenu
        items={[
          { value: Entity.House, label: "Дом" },
          { value: Entity.Business, label: "Бизнес" },
          { value: Entity.GasStation, label: "Заправка" },
          { value: Entity.Interior, label: "Интерьер" },
          { value: Entity.InteriorList, label: "Список интерьеров" },
          { value: Entity.Address, label: "Улицы и адреса" },
        ]}
        value={currentEntity}
        onChange={onChangeHandler}
      />
      {currentEntity ? (
        <div className="w-[25rem] h-full bg-dark-900 p-5 pr-3 gap-4 rounded-r-[1rem] rounded-bl-[1rem] flex flex-col">
          <Component onClose={() => setCurrentEntity(null)} />
        </div>
      ) : null}
    </CreateEntityWrapper>
  );
}
